import(/* webpackMode: "eager" */ "/home/runner/work/spcoin-nextjs-front-end/spcoin-nextjs-front-end/app/(menu)/page.tsx");
